import { useContext, useReducer } from 'react'
import { listReducer, listInitialState } from './reducer'
import { getAsync, postAsync, putAsync, deleteAsync } from '../../shared/api.service'
import { AuthContext } from '../../context/auth.context'
import { getEndpoint, handleException } from '../common/common'
import { useNotificationContext } from '../../context/notification/context'

export const types = {
  INIT: 'INIT',
  SUBMIT: 'SUBMIT',
  ERROR: 'ERROR',
  GET_SUCCESS: 'GET_SUCCESS',
  ADD_SUCCESS: 'ADD_SUCCESS',
  DELETE_SUCCESS: 'DELETE_SUCCESS'
}

const actionInit = () => dispatch => dispatch({ type: types.INIT })

const actionGet = (server, uri, args) => dispatch => (authContext, notificationContext) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (authContext) {
        await authContext.actions.checkExpRefresh()
      }

      let endpoint = getEndpoint(uri, args)

      dispatch({ type: types.SUBMIT })

      getAsync(server, endpoint)
        .then(({ data }) => {
          if (!data) data = []

          dispatch({ type: types.GET_SUCCESS, payload: data })
          resolve(data)
        })
        .catch(error => {
          dispatch({ type: types.ERROR, payload: error || '' })
          reject(error)
        })
    } catch (error) {
      // notificationContext.modal.error(error)
      handleException(error)
      reject(error)
    }
  })
}

const actionPost = (server, uri, args) => dispatch => (authContext, notificationContext) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (authContext) {
        await authContext.actions.checkExpRefresh()
      }

      let endpoint = getEndpoint(uri, args)

      dispatch({ type: types.SUBMIT })

      postAsync(server, endpoint, args.data)
        .then(({ data }) => {
          dispatch({ type: types.ADD_SUCCESS, payload: data })
          resolve(data)
        })
        .catch(error => {
          dispatch({ type: types.ERROR, payload: error || '' })
          reject(error)
        })
    } catch (error) {
      // notificationContext.modal.error(error)
      handleException(error)
      reject(error)
    }
  })
}

const actionPut = (server, uri, args) => dispatch => (authContext, notificationContext) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (authContext) {
        await authContext.actions.checkExpRefresh()
      }

      let endpoint = getEndpoint(uri, args)

      dispatch({ type: types.SUBMIT })

      putAsync(server, endpoint, args.data)
        .then(({ data }) => {
          dispatch({ type: types.UPDATE_SUCCESS, payload: data })
          resolve(data)
        })
        .catch(error => {
          // notificationContext.modal.error(error)
          dispatch({ type: types.ERROR, payload: error || '' })
          reject(error)
        })
    } catch (error) {
      handleException(error)
      reject(error)
    }
  })
}

const actionDelete = (server, uri, args) => dispatch => (authContext, notificationContext) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (authContext) {
        await authContext.actions.checkExpRefresh()
      }

      let endpoint = getEndpoint(uri, args)

      dispatch({ type: types.SUBMIT })

      deleteAsync(server, endpoint)
        .then(({ data }) => {
          dispatch({ type: types.DELETE_SUCCESS })
          resolve(data)
          notificationContext.toast.notify('delete success', 3000)
        })
        .catch(error => {
          // notificationContext.modal.error(error)
          dispatch({ type: types.ERROR, payload: error || '' })
          reject(error)
        })
    } catch (error) {
      handleException(error)
      reject(error)
    }
  })
}

export const useApiListState = (server, uri) => {
  const [state, dispatch] = useReducer(listReducer, listInitialState)

  const authContext = useContext(AuthContext)
  const notificationContext = useNotificationContext()

  const actions = {
    init: () => actionInit()(dispatch),

    get: (path, toast) => actionGet(server, uri, { path, toast })(dispatch)(authContext, notificationContext),
    getArgs: args => actionGet(server, uri, args)(dispatch)(authContext, notificationContext),

    post: (data, toast) => actionPost(server, uri, { data, toast })(dispatch)(authContext, notificationContext),
    postArgs: args => actionPost(server, uri, args)(dispatch)(authContext, notificationContext),

    put: (data, toast) => actionPut(server, uri, { path: data.id, data, toast })(dispatch)(authContext, notificationContext),
    putArgs: args => actionPut(server, uri, args)(dispatch)(authContext, notificationContext),

    delete: (path, toast) => actionDelete(server, uri, { path, toast })(dispatch)(authContext, notificationContext),
    deleteArgs: args => actionDelete(server, uri, args)(dispatch)(authContext, notificationContext)
  }

  return [actions, state]
}
